import isUndefined from "lodash/isUndefined"

export const strToBoolean = (value, defaultValue) =>
  isUndefined(value) ? defaultValue : value === true || value === "true"
